import { useTranslation } from 'react-i18next';

import type { Direction } from '../../theme';

// Derives the current document direction from the active language.
// `ar` (and any other RTL language we add later) → 'rtl'; everything else → 'ltr'.

const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur']);

export function useDirection(): Direction {
  const { i18n } = useTranslation();
  return RTL_LANGS.has(i18n.language) ? 'rtl' : 'ltr';
}
